import { Component, OnInit } from "@angular/core";
import { trigger, style, animate, transition } from "@angular/animations";
import { DatePipe } from "@angular/common";
import { MatSnackBar } from "@angular/material";
import { IMyOptions, IMyDateModel } from "mydatepicker";
import { SessionStorage } from "ngx-webstorage";
import { Observable } from "rxjs/Observable";
import { ExportExcelService } from "../../utils/services/export-excel.service";
import { ReportsService } from "./reports.service";
import { EditTimesheetService } from "../edit-timesheet/edit-timesheet.service";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { Angular2Csv } from "angular2-csv/Angular2-csv";
import {
  ReportType,
  projectList,
  ExportData,
  LockedList,
  LockedListIPDOExport,
  PendingTimesheet,
  EmployeeReportDeptWise,
  Timesheet,
  EmployeeReport,
  ProjectExport,
  ProjectIPDOExport,
  RmReport,
  UtilizationTimesheet,
  UtilizationReport,
  UtilizationIPDOReport,
  ExportIpdoDetailedView,
} from "./report";
import { EmpList, EmpDetails,EmpListforReport } from "../admin.interface";

@Component({
  selector: "app-reports",
  templateUrl: "./reports.component.html",
  styleUrls: ["./reports.component.css"],
  animations: [
    trigger("enterAnimation", [
      transition(":enter", [
        style({ opacity: 0 }),
        animate("500ms ease-in", style({ opacity: 1 })),
      ]),
    ]),
  ],
})
export class ReportsComponent implements OnInit {
  @SessionStorage() public config;
  @SessionStorage() public user;

  public timesheetLock: LockedList[] = [];
  public myDatePickerOptions: IMyOptions;
  public myDatePickerEndOptions: IMyOptions;
  public exportIndex: number;
  public startDate: any;
  public endDate: any;
  public report: Array<any> = [];
  public projectlistarr: any = []; // Array of Object of Employee working under logged RM is stored
  public filteredOptions: Observable<string[]>; // And Observable string array to store the filtered Employee List (Auto complete)
  public projectName: string; // Variable to store the employee name selected from autocomplete
  public employeelistarr: any = []; // Array of Object of Employee working under logged RM is stored
  public employeelistarrdeptwise:any=[];
  public empName: string; // Variable to store the employee name selected from autocomplete
  public rmName: string;
  public rmListarray: any = [];
  public rmProject: string;
  public exportData: any = new ExportData({});
  public pendingTimesheetList: Array<any> = [];
  public exportDetailedData: Array<any> = [];
  public pendingTimesheet: any = new PendingTimesheet({});
  public EmployeeReportDeptWise:any=new EmployeeReportDeptWise({})
  public LeaveFlag: boolean = false;
  public utilizationTimesheet: any = new UtilizationTimesheet({});
  public utilizationData: Array<any> = [];
  public pageNumber: number = 1;
  public pageSize: number = 10; // Page size for pagination purpose
  public totalElements: number = 0;
  public tabIndexPage: number = 0;
  public employeelist: EmpList[] = [];
  public employeesStatus;
  public totalEmployees :any;
  private alive: boolean = true;



  constructor(
    private datePipe: DatePipe,
    private exportExcel: ExportExcelService,
    private snackBar: MatSnackBar,
    private reportsService: ReportsService,
    private editTimesheetService: EditTimesheetService,
    private spinnerService: Ng4LoadingSpinnerService
  ) {
    const date: Date = new Date();
    date.setDate(date.getDate() + 1);

    this.myDatePickerOptions = {
      dateFormat: "dd-mm-yyyy",
      markCurrentDay: true,
      openSelectorTopOfInput: false,
      showSelectorArrow: false,
      editableDateField: false,
      showClearDateBtn: true,
      disableSince: {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
      },
    };

    this.myDatePickerEndOptions = {
      dateFormat: "dd-mm-yyyy",
      markCurrentDay: true,
      openSelectorTopOfInput: false,
      showSelectorArrow: false,
      editableDateField: false,
      showClearDateBtn: true,
      inline: false,
      disableSince: {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
      },
    };
  }

  ngOnInit() {
    const reportTitles = [
      "Project/s",
      "Utilization Hrs",
      "Locked Timesheet",
      "Timesheet",
      "Employee"
    ];
    reportTitles.map((ele) => this.report.push(new ReportType(ele)));
    this.employeesStatus = "active";

  }

  /**
   * @function lockedTimesheet
   * @description
   * Function to get the locked timesheet report details from the server and store it in the Array object
   * @var timesheetLock An array of object for storing the Locked timesheet details
   * @requires LockedList An Interface to create an Object in the desired format required for the Export data
   * @class  exportData An object which contains necessary data for file to export as CSV
   * @author gaurav.rao
   */
  lockedTimesheet() {
    this.timesheetLock = [];
    this.exportDetailedData = [];
    this.spinnerService.show();
    this.reportsService.getLockedList().subscribe(
      (response) => {
        this.spinnerService.hide();
        response.payload.lockedEmplist.map((value) =>
          this.timesheetLock.push(new LockedList(value))
        );
        this.exportData.data = this.timesheetLock; // Data to download as csv
        if (
          this.config.businessUnit === "ipdo" ||
          this.config.businessUnit === "biologics" ||
          this.config.businessUnit === "chinateam" ||
          this.config.businessUnit === "aps"
        ) {
          response.payload.lockedEmplist.map((value) =>
            this.exportDetailedData.push(
              new LockedListIPDOExport(value, this.config.businessUnit)
            )
          );
        }
        this.exportData.fileName = "Locked-Timesheet"; // Filename given for downloading the csv file
        this.exportData.pageHeading = ""; // First line Heading inside the CSV file
        this.exportData.flag = false; // Flag to enable/disable the export button. True= button disabled
        this.totalElements = this.exportData.data.length;
      },
      (error) => {
        this.spinnerService.hide();
      }
    );
  }

  /**
   * @function utilizationDatePicker()
   * @description
   * Function to call when the user changes the date in the Utilization tab in the view
   * Date is converted to yyyy-mm-dd format as per the Backend requirement
   * @callback getUtilizationReport After the model value is changed the new date is sent to backend and
   * the corresponding data is obtained for csv download
   * @var utilizationTimesheet A object with one key as date needs to be changed as per the user interaction in date picker
   * @requires DatePipe A pipe to transform JS Date to yyyy-mm-dd format
   * @author gaurav.rao
   */
  utilizationDatePicker() {
    this.pageNumber = 1;
    this.utilizationTimesheet.startDate = this.startDate
      ? this.datePipe.transform(this.startDate.jsdate, "yyyy-MM-dd")
      : "";
    this.utilizationTimesheet.endDate = this.endDate
      ? this.datePipe.transform(this.endDate.jsdate, "yyyy-MM-dd")
      : "";
    if (this.startDate && this.endDate) {
      if (this.startDate.epoc < this.endDate.epoc) {
        this.getUtilizationReport();
      } else {
        this.snackBar.open("Please select the valid date range", "OK", {
          duration: 3000,
        });
      }
    }
  }

  /**
   * @function getemployyeLists()
   * @description
   * A function to get the all the employee list from the API and store it for the view purpose
   * @var employeelistarr An array of object to store the list of employee for the view purpose
   * @author gaurav.rao
   */
  getEmployeeLists() {
    this.employeelistarr = [];
    this.spinnerService.show();
    this.editTimesheetService.getEmployeesDetails(null, null).subscribe(
      (data) => {
        this.spinnerService.hide();
        if (data.payload.employees) {
          data.payload.employees.map((value) =>
            this.employeelistarr.push(value)
          );
          this.filteredOptions = this.employeelistarr;
        }
      },
      (error) => {
        this.spinnerService.hide();
      }
    );
  }

  /**
   * @function getPendingTimesheet()
   * @description
   * Function to get all the timesheet from the API for the export
   * for the last tab of the report ie Timesheet which has various filters further where
   * admin can simplify the result based on the requirement
   * @var pendingTimesheetList An array of object which contains the details of the
   * all the employee timesheet with various fields
   * @requires exportData The class where all the neccesary data is stored which needs to be exported
   * @author gaurav.rao
   */
  getPendingTimesheet() {
    this.pageSize=15;
    this.pendingTimesheetList = [];
    if (this.startDate) {
      const startDate = this.startDate.formatted.split("-");
      this.myDatePickerEndOptions.disableUntil = {
        year: parseInt(startDate[2], 10),
        month: parseInt(startDate[1], 10),
        day: parseInt(startDate[0], 10),
      };
    }
    if (this.startDate && this.endDate) {
      this.spinnerService.show();
      this.pendingTimesheet.selectedstartDate = this.startDate
        ? this.datePipe.transform(this.startDate.jsdate, "yyyy-MM-dd")
        : "";
      this.pendingTimesheet.selectedendDate = this.endDate
        ? this.datePipe.transform(this.endDate.jsdate, "yyyy-MM-dd")
        : "";
      this.pendingTimesheet.pageNumber = this.pageNumber;
      this.pendingTimesheet.pageSize = this.pageSize;

      this.reportsService.getTimesheetReport(this.pendingTimesheet).subscribe(
        (data) => {
          this.spinnerService.hide();
          data.payload.reports.map((value) =>
            this.pendingTimesheetList.push(
              new Timesheet(value, this.pendingTimesheet.flag)
            )
          );
          this.exportData.data = this.pendingTimesheetList;
          if (
            this.config.businessUnit === "ipdo" ||
            this.config.businessUnit === "biologics" ||
            this.config.businessUnit === "chinateam" ||
            this.config.businessUnit === "aps"
          ) {
            this.exportDetailedData = [];
            data.payload.reports.map((value) =>
              this.exportDetailedData.push(
                new ExportIpdoDetailedView(value, this.pendingTimesheet.flag)
              )
            );
          }
          if (this.pendingTimesheet.flag === 1) {
            this.exportData.fileName = this.exportData.pageHeading =
              "Summarized_Timesheet_Report";
          } else if (this.pendingTimesheet.flag === 0) {
            this.exportData.fileName = this.exportData.pageHeading =
              "Detailed_Timesheet_Report";
          }
          this.exportData.flag = false;
          this.totalElements = data.payload.totalReport;
        },
        (error) => {
          this.spinnerService.hide();
        }
      );
    }

    else {
      this.spinnerService.hide();
      this.exportData.data = [];
      this.exportDetailedData = [];
    }
  }

  /**
   * @function timesheetRadioChange()
   * @description
   * Function to change radio button
   * @author Abhiraj SN
   */
  timesheetRadioChange(index) {
    this.pendingTimesheet.flag = index;
    if(index==4)
    {
      this.getEmployeelistforReport();
    }
    else{
      this.getPendingTimesheet();
    }
  }

   getEmployeelistforReport() {
    this.employeelist = [];
    // if (this.startDate) {
    //   const startDate = this.startDate.formatted.split("-");
    //   this.myDatePickerEndOptions.disableUntil = {
    //     year: parseInt(startDate[2], 10),
    //     month: parseInt(startDate[1], 10),
    //     day: parseInt(startDate[0], 10),
    //   };
    // // }
    // this.EmployeeReportDeptWise.selectedstartDate=this.startDate;
    // this.EmployeeReportDeptWise.selectedendDate=this.endDate;
    if (this.startDate && this.endDate &&
      !this.startDate.toString().includes('-') &&
      !this.endDate.toString().includes('-')){
      this.spinnerService.show();
      this.EmployeeReportDeptWise.selectedstartDate=this.startDate
        ? this.datePipe.transform(this.startDate.jsdate, "yyyy-MM-dd")
        : "";
        this.EmployeeReportDeptWise.selectedendDate = this.endDate
        ? this.datePipe.transform(this.endDate.jsdate, "yyyy-MM-dd")
        : "";
        this.EmployeeReportDeptWise.pageNumber = this.pageNumber;
      this.EmployeeReportDeptWise.pageSize = this.pageSize;
      this.EmployeeReportDeptWise.employeesStatus=this.employeesStatus;
      this.EmployeeReportDeptWise.totalEmployees=true;
      this.totalEmployees='true';

    this.spinnerService.show();
    this.reportsService
      .getEmployeesDetailsDeptwise(this.EmployeeReportDeptWise)
      .takeWhile(() => this.alive)
      .subscribe(
        (response) => {
          this.spinnerService.hide();
          this.totalElements = response.payload.totalemployees
            ? response.payload.totalemployees
            : 0;
          if (response.payload.employees) {
            response.payload.employees.map((value) =>
              this.employeelist.push(new EmpListforReport(value))
            );
            this.exportData.data=this.employeelist;
            // if (
            //   this.config.businessUnit === "ipdo" ||
            //   this.config.businessUnit === "biologics" ||
            //   this.config.businessUnit === "chinateam" ||
            //   this.config.businessUnit === "aps"
            // ) {
            //   this.exportDetailedData = [];
            //   response.payload.employees.map((value) =>
            //     this.exportDetailedData.push(
            //       new EmpListforReport(value)
            //     )
            //   );
            // }
            // if (this.EmployeeReportDeptWise.flag === 1) {
            //   this.exportData.fileName = this.exportData.pageHeading =
            //     "Summarized_Timesheet_Report";
            // } else if (this.EmployeeReportDeptWise.flag === 0) {
            //   this.exportData.fileName = this.exportData.pageHeading =
            //     "Detailed_Timesheet_Report";
            // }
            this.exportData.flag = false;

            // console.log(this.exportData.data,"vvvvvvv")
          }
        },
        (error) => {
          this.spinnerService.hide();
          this.snackBar.open("Error retriving the Employee list", "", {
            duration: 300,
          });
          this.employeelist.length = 0;
        }
      );
      }
      else{
        this.spinnerService.hide();
      this.exportData.data = [];
      this.exportDetailedData = [];
    }
  }
  /**
   * @function radioButtonChange()
   * @description
   * Function to get details based on tabs details
   * @author Abhiraj SN
   */
  radioButtonChange(index) {
    this.filteredOptions = null;
    this.tabIndexPage = index;
    this.pageNumber = 1;
    this.startDate = "";
    this.endDate = "";
    this.empName = "";
    this.projectName = "";
    this.exportData = new ExportData({});
    this.report.map((ele, i) => {
      if (i !== index) {
        ele.active = false;
      } else {
        ele.active = true;
        this.exportIndex = index;
      }
    });
    switch (index) {
      case 0:
        this.getProjectDetails();
        break;
      case 1:
        // this.getUtilizationReport();
        break;
      case 2:
        this.lockedTimesheet();
        break;
      case 3:
        this.getPendingTimesheet();
        this.getEmployeeLists();
        break;
      case 4:
        this.getDepartmentWiseTotalEmployeeData();
        break;
    }
  }

  /**
   * @function pendingTimesheetEmployee()
   * @description
   * Function to get pending timesheet detail
   * @author Abhiraj SN
   */
  pendingTimesheetEmployee(option) {
    this.pendingTimesheet.empno = option.employeeDetails.Empno;
    this.empName = option.employeeDetails.Empname;
    this.getPendingTimesheet();
  }

  employeeForReport(option)
  {
    this.EmployeeReportDeptWise.empno=option.Empno;
    this.getEmployeelistforReport()
  }

  get tableHeaders(): string[] {
  if (
    !this.exportData ||
    !this.exportData.data ||
    !this.exportData.data.length
  ) {
    return [];
  }

  const keys = new Set<string>();
  this.exportData.data.forEach((item: any) => {
    Object.keys(item).forEach(key => keys.add(key));
  });
  return Array.from(keys);
}

  /**
   * @function projectSelected()
   * @description
   * Function to get selected project detail
   * @author Abhiraj SN
   */
  projectSelected(option) {
    this.exportData.data = [];
    this.exportDetailedData = [];
    if (option.Project) {
      this.projectName = option.Project;
      option.empDetails.forEach((element, idx) => {
        this.exportData.data.push(
          new ProjectExport(element, option, idx, this.config.businessUnit)
        );
        if (
          this.config.businessUnit === "ipdo" ||
          this.config.businessUnit === "biologics" ||
          this.config.businessUnit === "chinateam" ||
          this.config.businessUnit === "aps"
        ) {
          this.exportDetailedData.push(
            new ProjectIPDOExport(
              element,
              option,
              idx,
              this.config.businessUnit === "ipdo" ||
                this.config.businessUnit === "chinateam" ||
                this.config.businessUnit === "aps"
            )
          );
        }
      });
      if (
        this.config.businessUnit === "ipdo" ||
        this.config.businessUnit === "biologics" ||
        this.config.businessUnit === "chinateam" ||
        this.config.businessUnit === "aps"
      ) {
        this.exportData.data.forEach((ele) => {
          ele["Time Spent"] = this.convertMinsToHrsMins(
            this.convertHoursToMins(ele["Time Spent"])
          );
        });
      }
      this.exportData.fileName = this.projectName + "_TimeSheet";
      this.exportData.pageHeading = option.Project;
      this.exportData.flag = false;
      this.totalElements = this.exportData.data.length;
    } else {
      this.projectName = "ALL";
      this.projectlistarr.forEach((data) => {
        data.empDetails.forEach((element, idx) => {
          this.exportData.data.push(
            new ProjectExport(element, data, idx, this.config.businessUnit)
          );
          if (
            this.config.businessUnit === "ipdo" ||
            this.config.businessUnit === "biologics" ||
            this.config.businessUnit === "chinateam" ||
            this.config.businessUnit === "aps"
          ) {
            this.exportDetailedData.push(
              new ProjectIPDOExport(
                element,
                data,
                idx,
                this.config.businessUnit
              )
            );
          }
        });
        if (
          this.config.businessUnit === "ipdo" ||
          this.config.businessUnit === "biologics" ||
          this.config.businessUnit === "chinateam" ||
          this.config.businessUnit === "aps"
        ) {
          this.exportData.data.forEach((ele) => {
            ele["Time Spent"] = this.convertMinsToHrsMins(
              this.convertHoursToMins(ele["Time Spent"])
            );
          });
        }
        this.exportData.fileName = this.projectName + "_Projects";
        this.exportData.pageHeading = option.Project;
        this.exportData.flag = false;
        this.totalElements = this.exportData.data.length;
      });
    }
  }

  /**
   * @function getProjectDetails()
   * @description
   * Function to get project detail
   * @author Abhiraj SN
   */


  getDepartmentWiseTotalEmployeeData()
  {
    this.employeelistarrdeptwise = [];
    this.spinnerService.show();
    this.reportsService.getDepartmentWiseTotalEmployeeData().subscribe(
      (data) => {
        this.spinnerService.hide();
        if (data.payload.employees) {
          data.payload.employees.map((value) =>
            this.employeelistarrdeptwise.push(value)
          );
          this.filteredOptions = this.employeelistarrdeptwise;
        }
      },
      (error) => {
        this.spinnerService.hide();
      }
    );
  }

  getProjectDetails() {
    this.projectlistarr = [];
    this.reportsService.getProjectList().subscribe((data) => {
      data.payload.projects.forEach((value) => {
        this.projectlistarr.push(new projectList(value));
      });
      this.filteredOptions = this.projectlistarr;
    });
  }

  /**
   * @function autoCompleteFilter()
   * @description
   * Function to validate filled project and employee
   * @author Abhiraj SN
   */
  autoCompleteFilter(event, index) {
    const searchItem = event.target.value;
    // if (event.target.value !== "undefined" && event.target.value !== "") {
    switch (index) {
      case 0:
        this.filteredOptions = this.projectlistarr.filter(
          (entity) =>
            entity.Project.toLowerCase().indexOf(searchItem.toLowerCase()) == 0
        );
        break;
      case 1:
        this.filteredOptions = this.employeelistarr.filter(
          (s) =>
            s.employeeDetails.Empname.toLowerCase().indexOf(
              searchItem.toLowerCase()
            ) != -1
        );
        break;
        case 4:
        this.filteredOptions = this.employeelistarrdeptwise.filter(
          (s) =>
            s.Empname.toLowerCase().indexOf(
              searchItem.toLowerCase()
            ) != -1
        );
        break;
    }
    // } else if (searchItem === "") {
    //   this.exportData = new ExportData({});
    // }

    if (!searchItem) {
      this.EmployeeReportDeptWise.empno=null;
      this.pendingTimesheet.empno=null;
    }
  }

  /**
   * @function getUtilizationReport()
   * @description
   * Function to get utilizaton report
   * @author Abhiraj SN
   */
  getUtilizationReport() {
    this.utilizationData = [];
    this.exportDetailedData = [];
    this.spinnerService.show();
    this.utilizationTimesheet.pageSize = this.pageSize;
    this.utilizationTimesheet.pageNumber = this.pageNumber;
    this.reportsService
      .getUtilizationReport(this.utilizationTimesheet)
      .subscribe(
        (res) => {
          this.spinnerService.hide();
          res.payload.reports.forEach((ele) => {
            this.utilizationData.push(
              new UtilizationReport(ele, this.config.businessUnit)
            );
            if (
              this.config.businessUnit === "ipdo" ||
              this.config.businessUnit === "biologics" ||
              this.config.businessUnit === "chinateam" ||
              this.config.businessUnit === "aps"
            ) {
              this.exportDetailedData.push(
                new UtilizationIPDOReport(ele, this.config.businessUnit)
              );
            }
            if (
              this.config.businessUnit === "ipdo" ||
              this.config.businessUnit === "biologics" ||
              this.config.businessUnit === "chinateam" ||
              this.config.businessUnit === "aps"
            ) {
              this.utilizationData.forEach((ele) => {
                ele["Time Spent"] = this.convertMinsToHrsMins(
                  this.convertHoursToMins(ele["Time Spent"])
                );
              });
            }
          });
          this.exportData.data = this.utilizationData;
          this.exportData.fileName =
            "Utilization Timesheet: (" +
            this.utilizationTimesheet.startDate +
            "-" +
            this.utilizationTimesheet.endDate +
            ")";
          this.exportData.pageHeading = this.exportData.fileName;
          this.exportData.flag = false;
          this.totalElements = res.payload.totalReport;
        },
        (err) => {
          this.spinnerService.hide();
          this.exportDetailedData = [];
        }
      );
  }

  /**
   * @function exportCSV()
   * @description
   * Function to export report
   * @author Abhiraj SN
   */
  exportCSV() {
    const options = {
      fieldSeparator: ",",
      quoteStrings: '"',
      decimalseparator: ".",
      showLabels: true,
      showTitle: true,
      title: this.exportData.fileName,
      useBom: true,
    };

    if (this.tabIndexPage === 1) {
      this.utilizationTimesheet.reportExport = true;
      this.spinnerService.show();
      this.reportsService
        .getUtilizationReport(this.utilizationTimesheet)
        .subscribe(
          (res) => {
            this.spinnerService.hide();
            this.exportDetailedData = [];

            if (
              this.config.businessUnit === "ipdo" ||
              this.config.businessUnit === "biologics" ||
              this.config.businessUnit === "chinateam" ||
              this.config.businessUnit === "aps"
            ) {
              res.payload.reports.forEach((ele) => {
                this.exportDetailedData.push(
                  new UtilizationIPDOReport(ele, this.config.businessUnit)
                );
              });
              this.exportData.fileName =
                "Utilization Timesheet: (" +
                this.utilizationTimesheet.startDate +
                "-" +
                this.utilizationTimesheet.endDate +
                ")";
              this.exportData.pageHeading = this.exportData.fileName;
              this.exportData.flag = false;
              this.totalElements = res.payload.totalReport;

              this.exportExcel.JSONToCSVConvertor(
                this.exportDetailedData,
                this.exportData.fileName,
                "Utilization Timesheet",
                true,
                true
              );

              new Angular2Csv(
                this.exportDetailedData,
                this.exportData.fileName,
                { headers: Object.keys(this.exportDetailedData[0]) }
              );
            } else {
              const exportedData = [];
              res.payload.reports.forEach((ele) => {
                exportedData.push(
                  new UtilizationReport(ele, this.config.businessUnit)
                );
              });
              this.exportData.pageHeading = this.exportData.fileName;
              this.exportData.flag = false;
              this.totalElements = res.payload.totalReport;
              new Angular2Csv(exportedData, this.exportData.fileName, {
                headers: Object.keys(exportedData[0]),
              });
            }
          },
          (err) => {
            this.spinnerService.hide();
            this.exportDetailedData = [];
          }
        );
    }
     else if (this.tabIndexPage === 3) {
      this.pendingTimesheet.reportExport = true;
      this.spinnerService.show();
      this.reportsService.getTimesheetReport(this.pendingTimesheet).subscribe(
        (data) => {
          this.spinnerService.hide();
          this.exportDetailedData = [];
          if (
            this.config.businessUnit === "ipdo" ||
            this.config.businessUnit === "biologics" ||
            this.config.businessUnit === "chinateam" ||
            this.config.businessUnit == "aps"
          ) {
            data.payload.reports.map((value) =>
              this.exportDetailedData.push(
                new ExportIpdoDetailedView(value, this.pendingTimesheet.flag)
              )
            );
            this.exportData.fileName = this.exportData.pageHeading =
              "Detailed Timesheet Report";
            this.exportData.flag = false;
            this.totalElements = data.payload.totalReport;
            if (this.pendingTimesheet.flag === 1) {
              this.exportData.fileName = this.exportData.pageHeading =
                "Summarized Timesheet Report";
            } else if (this.pendingTimesheet.flag === 0) {
              this.exportData.fileName = this.exportData.pageHeading =
                "Detailed Timesheet Report";
            }
            this.exportExcel.JSONToCSVConvertor(
              this.exportDetailedData,
              this.exportData.fileName,
              "Detailed Timesheet Report",
              true,
              true
            );
            // new Angular2Csv(this.exportDetailedData, this.exportData.fileName, { headers: Object.keys(this.exportDetailedData[0]) });
          }

          else {
            const exportedData = [];
            data.payload.reports.map((value) =>
              exportedData.push(
                new Timesheet(value, this.pendingTimesheet.flag)
              )
            );
            if (this.pendingTimesheet.flag === 1) {
              this.exportData.fileName = this.exportData.pageHeading =
                "Summarized Timesheet Report";
            } else if (this.pendingTimesheet.flag === 0) {
              this.exportData.fileName = this.exportData.pageHeading =
                "Detailed Timesheet Report";
            }
            this.exportData.flag = false;
            this.totalElements = data.payload.totalReport;
            new Angular2Csv(exportedData, this.exportData.fileName, {
              headers: Object.keys(exportedData[0]),
            });
          }
        },
        (error) => {
          this.spinnerService.hide();
        }
      );
    }
    else if (this.tabIndexPage === 4) {
      this.EmployeeReportDeptWise.reportExport = true;
      this.spinnerService.show();
      this.reportsService.getEmployeesDetailsDeptwise(this.EmployeeReportDeptWise).subscribe(
        (response) => {
          this.spinnerService.hide();
          this.exportDetailedData = [];
          if (
            this.config.businessUnit === "ipdo" ||
            this.config.businessUnit === "biologics" ||
            this.config.businessUnit === "chinateam" ||
            this.config.businessUnit == "aps"
          ) {
            response.payload.employees.map((value) =>
              this.exportDetailedData.push(
                new EmpListforReport(value)
              )
            );
            if (this.EmployeeReportDeptWise.flag === 1) {
              this.exportData.fileName = this.exportData.pageHeading =
                "Summarized_Timesheet_Report";
            } else if (this.EmployeeReportDeptWise.flag === 0) {
              this.exportData.fileName = this.exportData.pageHeading =
                "Detailed_Timesheet_Report";
            }
            this.exportExcel.JSONToCSVConvertor(
              this.exportDetailedData,
              this.exportData.fileName,
              "Detailed Timesheet Report",
              true,
              true
            );
            // new Angular2Csv(this.exportDetailedData, this.exportData.fileName, { headers: Object.keys(this.exportDetailedData[0]) });
          }

          else {
            const exportedData = [];
            response.payload.employees.map((value) =>
              exportedData.push(
                new EmpListforReport(value)
              )
            );
            if (this.pendingTimesheet.flag === 1) {
              this.exportData.fileName = this.exportData.pageHeading =
                "Summarized Timesheet Report";
            } else if (this.pendingTimesheet.flag === 0) {
              this.exportData.fileName = this.exportData.pageHeading =
                "Detailed Timesheet Report";
            }
            this.exportData.flag = false;
            this.totalElements = response.payload.totalEmployees;
            new Angular2Csv(exportedData, this.exportData.fileName, {
              headers: Object.keys(exportedData[0]),
            });
          }
        },
        (error) => {
          this.spinnerService.hide();
        }
      );
    }


    else {
      if (this.exportData.data.length > 0) {
        if (
          this.config.businessUnit === "ipdo" ||
          this.config.businessUnit === "biologics" ||
          this.config.businessUnit === "chinateam" ||
          this.config.businessUnit === "aps"
        ) {
          // setTimeout(() => {
          //   console.log("hello");
          // }, 1000);

          this.exportExcel.JSONToCSVConvertor(
            this.exportDetailedData,
            this.exportData.fileName,
            this.exportData.fileName,
            true,
            true
          );
          // tslint:disable-next-line:no-unused-expression

          // new Angular2Csv(this.exportDetailedData, this.exportData.fileName, { headers: Object.keys(this.exportDetailedData[0]) });
        } else {
          // tslint:disable-next-line:no-unused-expression
          new Angular2Csv(this.exportData.data, this.exportData.fileName, {
            headers: Object.keys(this.exportData.data[0]),
          });
        }
      } else {
        this.snackBar.open("No data to export", "OK", {
          duration: 3000,
        });
      }
    }
  }

  /**
   * @function triggerChange()
   * @description
   * A function called upon change of pagination by admin
   * @param data The variable which holds the page number has per the Admin click events
   * @var pageNumber A variable to store the selected page from pagination tab
   * @requires getEmployeelist A function is called upon every change in pagination event triggered
   * @author gaurav.rao
   */
  triggerChange(data: any) {
    this.pageNumber = data;
    if (this.tabIndexPage === 3) {
      this.getPendingTimesheet();
    } else if (this.tabIndexPage === 1) {
      this.getUtilizationReport();
    }
    else if(this.tabIndexPage==4)
    {
      this.getEmployeelistforReport()
    }
  }

  /**
   * @function convertHoursToMins()
   * @description
   * Function to covert hour to mins
   * @author Abhiraj SN
   */
  convertHoursToMins(hrs) {
    const a = hrs.toString().split(":");
    let minutes = 0;
    if (a[1]) {
      minutes = +a[0] * 60 + +a[1];
    } else {
      minutes = +Number(a[0]) * 60;
    }
    return minutes;
  }

  /**
   * @function convertHoursToMins()
   * @description
   * Function to covert mins to hours
   * @author Abhiraj SN
   */
  convertMinsToHrsMins(mins) {
    const h: any = Math.floor(mins / 60);
    let m: any = mins % 60;
    m = Math.round(m);
    const hrs = h < 10 ? "0" + h : h;
    const mns = m < 10 ? "0" + m : m;
    return `${hrs}:${mns}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/reports/reports.component.ts